import axios from 'axios'
import pako from 'pako'

const language = localStorage?.getItem('language') || 'zh-CN'
// 解压并解析 JSON 文件的方法
export async function fetchAndDecompressJson(url) {
  try {
    // 获取压缩文件的二进制数据
    const response = await axios.get(url, {
      responseType: 'arraybuffer' // 获取二进制数据
    })
    // 解压数据
    const compressedData = new Uint8Array(response.data)
    const decompressedData = pako.inflate(compressedData)
    // 将解压后的数据转为 JSON 字符串
    const json = new TextDecoder().decode(decompressedData)
    // 解析并返回 JSON 对象
    return json ? JSON.parse(json) : {}
  } catch (error) {
    console.error('解压文件或解析 JSON 失败', error)
    //定位问题
    localStorage?.setItem('languageLog', '解压文件或解析 JSON 失败')
    throw error // 抛出错误以便调用方处理
  }
}



// WEBPACK FOOTER //
// ../@ost/lib/common/lang.js